export default __webpack_public_path__ + "static/media/no-policy.782d7ca8.svg";